export type UniversalStatistics = {
    orvestoData: string;
    dataLake: {
        product: {
            viewId: string;
            viewType: string;
        };
    };
};

export const errorStatistics = (status: number, path: string): UniversalStatistics =>
    // Fel/[namn på fel]/[view id för sida om det går att ta fram]
    ({
        orvestoData: `/fel/fel/${status}`,
        dataLake: {
            product: {
                viewId: `fel/${status}${path}`,
                viewType: 'fel',
            },
        },
    });
